import { render } from "./CreateProductsPage.vue?vue&type=template&id=d37994c4&scoped=true&ts=true"
import script from "./CreateProductsPage.vue?vue&type=script&lang=ts"
export * from "./CreateProductsPage.vue?vue&type=script&lang=ts"

import "./CreateProductsPage.vue?vue&type=style&index=0&id=d37994c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d37994c4"]])

export default __exports__